import {Button} from "@/components/button/Button.tsx";
import {Chip} from "@/components/chip/Chip.tsx";
import {EllipsisText} from "@/components/typography/EllipsisText.tsx";
import {NetworkProbeResult} from "@/lib/types/network.ts";

import {formatSeconds, originLabel} from "./networkProbe.utils.ts";

import styles from "./NetworkRunTestResultList.module.scss";

export const NetworkRunTestResultList = ({
  probes,
  onOpenProbe,
}: {
  probes: NetworkProbeResult[];
  onOpenProbe: (index: number) => void;
}) => (
  <ul className={styles.results}>
    {probes.map((probe, index) => (
      <li key={index} className={styles.resultRow}>
        <Chip className={styles.resultPill} variant={probe.status === "PASS" ? "success" : "danger"} size="small">
          {probe.status === "PASS" ? "Passed" : "Failed"}
        </Chip>
        <span className={styles.rowBody}>
          <EllipsisText className={styles.resultName}>{originLabel(probe.origin)}</EllipsisText>
          <span className={styles.resultSubLine}>
            <EllipsisText className={styles.subNetwork}>
              {probe.origin.network} AS{probe.origin.asn}
            </EllipsisText>
            <span className={styles.subDivider} />
            <span className={styles.subHttp}>{probe.status_code === null ? "—" : `HTTP ${probe.status_code}`}</span>
            <span className={styles.subDivider} />
            <span className={styles.subTime}>{formatSeconds(probe.response_time_ms)}</span>
          </span>
        </span>
        <span className={styles.tracerouteCol}>
          <Button variant="linkBlue" size="text" typography="link" onClick={() => onOpenProbe(index)}>
            {probe.traceroute ? "Traceroute" : "Details"}
          </Button>
        </span>
      </li>
    ))}
  </ul>
);
